const KEY = 'onboardingProfileSkipped';

/**
 * "Skip for now" has no server-side representation — the profile is complete only once
 * the user has a name, so without a client-side flag `currentStep` sends them straight
 * back to the profile step and the button appears dead. Session storage keeps the skip
 * across a reload without leaking it to another device, which matches "for now".
 */
export function isProfileSkipped(): boolean {
  try {
    return sessionStorage.getItem(KEY) === 'true';
  } catch {
    // Private browsing and blocked site data both throw on access.
    return false;
  }
}

export function skipProfile(): void {
  try {
    sessionStorage.setItem(KEY, 'true');
  } catch {
    // Non-fatal: the user simply sees the profile step again after a reload.
  }
}
